import { Box, DialogTitle, Typography, styled } from "@mui/material";
import { useCropperStore } from "@src/v3.0.0/store/cropper/cropper-store";

const CommandDisplay = styled(Typography)`
  max-width: 100px;
`;

export default function CropperCommands() {
  const { undo, redo } = useCropperStore();
  return (
    <Box>
      <DialogTitle>Commands</DialogTitle>
      <Typography>Redo</Typography>
      {redo.map(element => {
        return (
          <CommandDisplay>{JSON.stringify(element)}</CommandDisplay>
        )
      })}
      <Typography>Undo</Typography>
      {undo.map(element => {
        return (
          <CommandDisplay>{JSON.stringify(element)}</CommandDisplay>
        )
      })}
    </Box>
  )
}